import React, { useState, Fragment, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { MsalContext } from "src/components/Contexts/MsalContext"
import { APIContext } from "src/components/Contexts/APIContext"
import { isNull } from "util"
import { SavedFiltersViewModel } from "../ViewModels/SavedFiltersViewModel"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import TextField from "@mui/material/TextField"
import Dropdown from "../Utilities/Dropdown"
import Button from "@mui/material/Button"
import CallTableViewModel from "../ViewModels/CallTableViewModel"
import { StrictTextFieldValidator } from "./ReworkedFilters/Utility/InputValidation"

interface ISaveFiltersDialogProps {
    open: boolean;
    close: () => void;
    callTableViewModel: CallTableViewModel;
    toggleNewFilter?: () => void;
}

export default function SaveFiltersDialog(props: ISaveFiltersDialogProps) {
    const { msalFetch } = useContext(MsalContext);
    const { isAdmin } = useContext(APIContext);
    const navigate = useNavigate();

    const [queryName, setQueryName] = useState('');
    const [saveFilterRole, setSaveFilterRole] = useState('User');

    const onNameChange = (e) => {
        if (StrictTextFieldValidator(e.target.value))
            setQueryName(e.target.value)
    };

    const closeSaveDialog = () => {
        props.close();
        setQueryName('');
    }

    const SavedFilterRole = (e) => setSaveFilterRole(e);

    const saveFilters = () => {
        let url = 'api/Search/SaveFilter?FilterName=' + queryName + '&Role=' + saveFilterRole;

        msalFetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            dataType: 'json',
            body: JSON.stringify(props.callTableViewModel)
        })
            .then(response => response.json())
            .then(data => {
                closeSaveDialog();
                if (props.toggleNewFilter !== undefined) {
                    props.toggleNewFilter();
                }
                newFilter(data);
            });
    }

    const newFilter = (data: SavedFiltersViewModel) => navigate('/Search/SearchIndex?client=' + encodeURIComponent(data.client) + '&filter=' + encodeURIComponent(data.guid))

    return (
        <Fragment>
            <Dialog open={props.open} onClose={closeSaveDialog} fullWidth maxWidth="sm">
                <DialogContent>
                    <DialogContentText>Choose a name for this query.</DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Query Name"
                        fullWidth
                        value={queryName}
                        onChange={onNameChange}
                    />
                </DialogContent>
                <DialogActions>
                    {
                        isAdmin
                        &&
                        <Dropdown
                            fullWidth
                            dropdownLabel="Select Filter Type"
                            dropdownList={['User', 'System']}
                            dropdownDefault='User'
                            onSelect={SavedFilterRole}
                        />
                    }
                    <Button
                        onClick={closeSaveDialog}
                        color="primary">
                        Cancel
                    </Button>
                    <Button
                        disabled={isNull(queryName) || queryName === ""}
                        onClick={saveFilters}
                        color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    )
}